// extracted by css-extract-rspack-plugin
export default {"loading-icon":"RmYVl5","loadingIcon":"RmYVl5","loading-opacity":"FX9325","loadingOpacity":"FX9325"};